import React, { Suspense, lazy, useEffect } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import './App.scss'

const Agora = lazy(() => import('../pages/Agora'))
const Aws = lazy(() => import('../pages/Aws'))
const Rte = lazy(() => import('../pages/Rte'))
const TxLight = lazy(() => import('../pages/TxLight'))

function App() {
  function Home() {
    useEffect(() => {
      window.location.href = 'https://segmentfault.com/'
    }, [])
    return <br />
  }
  return (
    <div className="App">
      <Router basename="/page/">
        <Suspense fallback={<div style={{ backgroundColor: '#fff' }} />}>
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route path="/rtc-hackathon-2020">
              <Agora />
            </Route>
            <Route path="/aws-hackathon-2020">
              <Aws />
            </Route>
            <Route path="/rte-hackathon-2020">
              <Rte />
            </Route>

            <Route path="/tx-light">
              <TxLight />
            </Route>
          </Switch>
        </Suspense>
      </Router>
    </div>
  )
}

export default App
